import axios from 'axios'
import config from '../config'
import {
    Message
} from 'element-ui';
import {
    startLoading,
    endLoading
} from '../processing'
import {
    handleError
} from '../index'
import qs from 'qs'
import cookie from 'js-cookie'
import quit from '@/common/quit.js'

axios.defaults.baseURL = config.baseURL

function authHeader() {
    return {
        'x-auth-token': cookie.get('token')
    }
}

let base64 = ''

axios.interceptors.request.use(
    config => {
        // if (!window.navigator.onLine) { // 判断是否存连接上了网络
        //     Message.error('当前网络已断开，请检查网络后重试！')
        // }
        return config
    },
    err => {
        return Promise.reject(err)
    })


// const handleError = (error) => {
//     let response = error.response
//     if (response && (response.status == 401 || response.status == 403)) {
//         quit()
//     } else {
//         if (response && error.response.data) {
//             Message.error(error.response.data.message)
//         } else {
//             Message.error(error.toString())
//         }
//     }
// }

export default {
    login: async (username, password) => {
        startLoading();
        try {
            let result = await axios.post('/login', qs.stringify({
                username,
                password
            }), {
                emulateJSON: true
            })
            endLoading()
            return result.headers['x-auth-token']
        } catch (error) {
            endLoading()
            Message.error('账号或密码错误，请重新登录')
        }
    },
    getTrainLogsList: async (params) => {
        startLoading();
        try {
            params.phone = '13000000000'
            params.size = 20
            let result = await axios.get('/log', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getHome: async (token) => {
        startLoading()
        try {
            let result = await axios.get('/home', {
                headers: {
                    'x-auth-token': token
                }
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAcountList: async (params) => {
        startLoading();
        try {
            params.sort = 'createdAt,DESC'
            params.size = 20
            let result = await axios.get('/user', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getGroupOptometristList: async (params) => {
        startLoading();
        try {
            // let params = {}
            params.sort = 'createdAt,DESC'
            params.size = 20
            let result = await axios.get('/group/optometrist', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getProvinceList: async (type) => {
        startLoading();
        try {
            let result
            if (type === 'optometrist') {
                result = await axios.get('/district/optometrist', {
                    headers: authHeader()
                })
            } else if (type === 'agent') {
                result = await axios.get('/district/agent', {
                    headers: authHeader()
                })
            } else if (type === 'superAdmin') {
                result = await axios.get('/district/province', {
                    headers: authHeader()
                })
            } else if (type === 'superAdminRegion') {
                result = await axios.get('/district/available/province', {
                    headers: authHeader()
                })
            } else if (type === 'regionManager') {
                result = await axios.get('/district/region', {
                    headers: authHeader()
                })
            } else {
                result = await axios.get('/district/province', {
                    headers: authHeader()
                })
            }
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgenteAuthorizedList: async () => {
        startLoading();
        try {
            let params = {
                size: 200
            }
            let result = await axios.get('/agent/station/authorized/all', {
                headers: authHeader(),
                params
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateAgenteAuthorized: async (type, data) => {
        startLoading();
        try {
            if (type === 'add') {
                await axios.post('/agent/station/subordinate', data, {
                    headers: authHeader()
                })
            } else if (type === 'remove') {
                await axios.delete('/agent/station/subordinate', {
                    data: data,
                    headers: authHeader()
                }, )
            }

            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentAccountById: async (userID, station, params) => {
        startLoading();
        try {
            let url = `/agent/subordinate/${userID}`
            if (station) url += '/station'
            let result = await axios.get(url, {
                params: params ? params : null,
                headers: authHeader()
            })
            endLoading()
            return result.data
            // return 'aa'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getGroupOptometristById: async (userID, district) => {
        startLoading();
        try {
            let url = `/group/optometrist/${userID}`
            if (district) url += '/district'
            let result = await axios.get(url, {
                headers: authHeader()
            })
            endLoading()
            return result.data
            // return 'aa'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    addOptometristDistrict: async (data) => {
        startLoading();
        try {
            await axios.post('/group/optometrist/district/bind', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    deleteOptometristDistrict: async (data) => {
        startLoading();
        try {
            await axios.delete('/group/optometrist/district/unbind', {
                data: data,
                headers: authHeader()
            }, )
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentAcountList: async (params) => {
        startLoading();
        try {
            // let params = {}
            params.sort = 'createdAt,DESC'
            params.size = 200
            let result = await axios.get('/agent/subordinate', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateAgentAccountInfo: async (operation, data) => {
        startLoading()
        try {
            console.log('operation, data', operation, data)
            let result
            if (operation === 'deleteAccount') {
                result = await axios.delete('/agent/subordinate', {
                    params: {
                        subordinateId: data
                    },
                    headers: authHeader()
                })
                console.log('result', result)
            } else if (operation === 'addAccount') {
                result = await axios.post('/agent/subordinate', data, {
                    headers: authHeader()
                })
            } else {
                result = await axios.put('/agent/subordinate', data, {
                    headers: authHeader()
                })
            }

            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getGroupAcountList: async (params) => {
        startLoading();
        try {
            // let params = {}
            params.sort = 'createdAt,DESC'
            params.size = 20
            let result = await axios.get('/group/user', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateAcountInfo: async (operation, data) => {
        startLoading()
        try {
            let result
            if (operation === 'deleteAccount') {
                result = await axios.delete('/group/user', {
                    params: {
                        userId: data,
                    },
                    headers: authHeader()
                })
            } else if (operation === 'addAccount') {
                result = await axios.post('/group/user', data, {
                    headers: authHeader()
                })
            } else {
                result = await axios.put('/group/user', data, {
                    headers: authHeader()
                })
            }

            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    addAcount: async (info /**{name, contact, contactPhone} */ ) => {
        startLoading()
        try {
            await axios.post('/user', info, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    checkAdminPwd: async (pwd) => {
        startLoading()
        try {
            base64 = 'Basic ' + window.btoa(cookie.get('username') + ':' + pwd)
            let headers = {
                Authorization: base64
            }
            await axios.get('/user/auth', {
                headers
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            return 'failed'
        }
    },
    deleteAcount: async (id) => {
        startLoading()
        try {
            await axios.delete(`/user/${id}`, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateAcount: async (id, params, base) => {
        startLoading()
        try {
            await axios.post(`/user/${id}`, params, {
                headers: base ? {
                    Authorization: base64
                } : authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAcountInfo: async (id) => {
        startLoading()
        try {
            let result = await axios.get(`/user/${id}`, {
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    pay: async (params) => {
        startLoading()
        try {
            let result = await axios.post('/treatment', params, {
                headers: authHeader()
            })
            let id = result.data.data
            result = await axios.post(`/treatment/${id}/pay`, {}, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getGameList: async (type) => {
        startLoading()
        try {
            let result = await axios.get(`/game?label=${type}`, {
                headers: authHeader()
            })
            endLoading()
            return result;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getBGConfig: async (id, level) => {
        startLoading()
        try {
            let url = `/game/config?gameId=${id}&level=${level}`
            // if (level > -1) {
            //     url = `http://vision-api.yottasystem.com/game/level?gameId=42377cfa-c81d-401a-bcf5-6173d4f8de59&level=1`
            // }

            let result = await axios.get(url, {
                headers: authHeader()
            })
            endLoading()
            return result;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getBGConfigDefault: async (id) => {
        startLoading()
        try {
            let url = `/game/${id}/background/resource/default`
            let result = await axios.get(url, {
                headers: authHeader()
            })
            endLoading()
            return result;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPrecisionConfig: async (id) => {
        startLoading()
        try {
            let url2 = `/configuration/${id}`
            let result = await axios.get(url2, {
                headers: authHeader()
            })
            endLoading()
            return result;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    postPrecisionConfig: async (config) => {
        startLoading()
        try {
            let result = await axios.post(`/configuration`, config, {
                headers: authHeader()
            })
            endLoading()
            return result;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    postBGConfig: async (id, config) => {
        startLoading()
        try {
            let result = await axios.post(`/game/${id}/config`, config, {
                headers: authHeader()
            })
            endLoading()
            return result;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    changeShowPrompt: async (userId, isProductinformation) => {
        startLoading();
        try {
            let result = await axios.post(`/user/${userId}`, {
                showPrompt: isProductinformation
            }, {
                headers: authHeader()
            })
            endLoading()
            return result;
        } catch (error) {
            endLoading()
            Message.error('error')
        }
    },
    getGameReplay: async (playerId, start, end, day) => {
        startLoading()
        try {
            const params = {
                size: 1000
            }
            let result = await axios.get(`/playback?player=${playerId}&start=${start}&end=${end}`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getStationPatientList: async (params, id) => {
        startLoading();
        try {
            params.sort = 'createdAt,DESC'
            params.size = 10
            let url = `/station/${id}/patient`
            let result = await axios.get(url, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getGames: async(params) => {
        startLoading();
        try {
            let url = `/game/list`
            let  result = await axios.get(url, {headers: authHeader()});
            endLoading();
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    saleAGame: async(param) => {
        startLoading();
        try {
            let url = `/game/sales`
            let result = await axios.post(url, param, {
                headers: authHeader()
            })
            endLoading()
            return 'success' 
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    singlePlanEdit: async(data) => {
        startLoading();
        let url = '/exercise/single/edit'
        try {
            let result = await axios.post(url, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success' 
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    singlePlanReset: async(data) => {
        startLoading();
        let url = "/exercise/single/reset"
        try {
            let result = await axios.put(url,null,{
                headers: authHeader(),
                params: data
            })
            endLoading()
            return 'success' 
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    singlePlanDelete: async(data) => {
        startLoading();
        let url = "/exercise/single/deletePlan"
        try {
            let result = await axios.delete(url, {
                params: data,
                headers: authHeader()
            })
            endLoading()
            return 'success' 
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    deleteAllPlanNoPlay: async(data) => {
        startLoading();
        let url = "/exercise/single/deleteAllPlanNoPlay"
        try {
            let result = await axios.delete(url, {
                params: data,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getSalesPromotions: async(params) => {
        startLoading();
        try {
            let url = `/sales/promotion/list`
            let result = await axios.get(url, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            console.log("result.data")
            console.log(result.data)
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getSupervisedPatientList: async (params) => {
        startLoading();
        try {
            params.sort = 'createdAt,DESC'
            params.size = 10
            let url = `/station/patient`
            let result = await axios.get(url, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentStationList: async () => {
        startLoading();
        try {
            let params = {}
            // params.sort = 'createdAt,DESC'
            // params.size = 20
            let result = await axios.get('/doctor/agent/station', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    addAgentOptometristPatient: async (data) => {
        startLoading();
        try {
            await axios.post('/patient', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientTrackList: async (params) => {
        startLoading();
        try {
            // let params = {}
            // params.sort = 'trainingAt,DESC'
            params.size = 10
            let result = await axios.get('/patient/training/track?sort=trainingAt,DESC&sort=id', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientDetailById: async (params, patientId) => {
        startLoading();
        try {
            const url = `/patient/${patientId}/training/track`
            let result = await axios.get(url, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    DoctorGetPatientDetailByPatientId: async (patientId) => {
        startLoading();
        try {
            const url = `/patient/${patientId}`
            let result = await axios.get(url, {
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    savePatientTrainingReamrk: async (data) => {
        startLoading();
        try {
            await axios.put('/patient/training/track', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    resetPatientTrainingReamrk: async (trackId) => {
        startLoading();
        try {
            await axios.post(`/patient/training/track/${trackId}/reset`, {}, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getGameDetileTable: async (trainingId) => {
        startLoading()
        let url = `patient/training/${trainingId}/result`
        try {
            let result = await axios.get(url, {
                headers: authHeader()
            })
            endLoading()
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    editGameStartLevelList: async (patientId, formData) => {
        startLoading()
        try {
            if (formData) {
                let url = `/patient/game/begin/level`
                await axios.put(url, formData, {
                    headers: authHeader()
                })
                endLoading()
                return 'success';
            } else {
                let url = `patient/${patientId}/game/begin/level`
                let result = await axios.get(url, {
                    headers: authHeader()
                })
                endLoading()
                return result.data;
            }
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getStationDetileInfo: async (stationId) => {
        startLoading()
        let url = `/station/${stationId}`
        try {
            let result = await axios.get(url, {
                headers: authHeader()
            })
            endLoading()
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getMyGames: async (params) => {
        startLoading()
        try {
            let result = await axios.get("/game/user/sales", {params: params, headers: authHeader()});
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    exercisePlan: async (data) => {
        startLoading()
        try {
            let result = await axios.post("/exercise/plan", data, {
                headers: authHeader()
            });
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientSinglePurchaseHistory: async (params) => {
        startLoading()
        let url = `/patient/single/purchase`
        try {
            let result = await axios.get(url, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientPurchaseHistory: async (patientId, params) => {
        startLoading()
        let url = `/patient/${patientId}/purchase/history`
        try {
            let result = await axios.get(url, {
                headers: authHeader(),
                params: params
            })
            endLoading()
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentPurchaseHistory: async (agentId, params) => {
        startLoading()
        let url = agentId == undefined ? `/region/agent/purchase/history` : `/region/agent/${agentId}/purchase/history`
        try {
            let result = await axios.get(url, {
                headers: authHeader(),
                params: params
            })
            endLoading()
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getTallyBookAgent: async(params) => {
        startLoading();
        try {
            let result = await axios.get("/distribution/agent/tally/book",{headers: authHeader(), params: params})
            endLoading();
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getTallyBookStation: async(params) => {
        startLoading();
        try {
            let result = await axios.get("/distribution/station/tally/book",{headers: authHeader(), params: params})
            endLoading();
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updatePatientPayGoods: async (data, slectTab) => {
        startLoading();
        try {
            let params = {}
            // params.sort = 'createdAt,DESC'
            // params.size = 20
            if (slectTab === 'BUY') {
                await axios.post('/patient/treatment/pay', data, {
                    params: params,
                    headers: authHeader()
                })
            } else if (slectTab === 'salesReturn') {
                await axios.post('/patient/treatment/refund/apply', data, {
                    params: params,
                    headers: authHeader()
                })
            }
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    RetrievePassword: async (type, data, userID) => {
        startLoading();
        try {
            console.log('data', type, data)
            let result = undefined
            if (type === 'sendSms') {
                result = await axios.get(`/user/verification/code`, {
                    params: data,
                })
            } else if (type === 'verifySms') {
                result = await axios.post('/user/verification/code', data, {})
            }
            endLoading()
            return result
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateLoninUserInfo: async (type, data, userId) => {
        startLoading();
        try {
            let result = undefined
            if (type === 'sendSms') {
                result = await axios.get(`/user/verification/code`, {
                    params: data,
                    headers: authHeader()
                })
            } else if (type === 'verifySms') {
                result = await axios.post(`/user/${userId}/verification/code`, data, {
                    headers: authHeader()
                })
            } else if (type === 'updatePwd') {
                base64 = 'Basic ' + window.btoa(cookie.get('username') + ':' + data.oldPassword)
                result = await axios.post(`/user/${userId}`, data, {
                    headers: {
                        'x-auth-token': cookie.get('token'),
                        Authorization: base64
                    }
                })
            }
            endLoading()
            return result
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateGameLevelManagement: async (data) => {
        startLoading()
        let url = `/game`
        try {
            let result = await axios.put(url, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success';
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getRecentlyClientVersion: async () => {
        startLoading()
        let url = `/client`
        try {
            let result = await axios.get(url, {
                headers: authHeader(),
            })
            endLoading()
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateClientVersion: async (data) => {
        startLoading()
        let url = `/client`
        try {
            let result = await axios.post(url, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success';
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    adminGetTrainWeight: async (gameId) => {
        startLoading()
        let url = `/game/${gameId}`
        try {
            let result = await axios.get(url, {
                headers: authHeader(),
            })
            endLoading()
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateTrainWeight: async (gameId, data) => {
        startLoading()
        let url = `/game/${gameId}/weight`
        try {
            let result = await axios.put(url, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success';
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getStimulusModeList: async () => {
        startLoading()
        let url = `/game/stimulus/modes`
        try {
            let result = await axios.get(url, {
                headers: authHeader()
            })
            endLoading()
            return result;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getStimulusModeById: async (params) => {
        startLoading()
        let url = `/game/stimulus/mode/level`
        try {
            let result = await axios.get(url, {
                headers: authHeader(),
                params,
            })
            endLoading()
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateStimulusModeById: async (data) => {
        startLoading()
        let url = `/game/stimulus/mode/level`
        try {
            let result = await axios.post(url, data, {
                headers: authHeader(),
            })
            endLoading()
            return 'success';
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateStimulusModeConfigById: async (data) => {
        startLoading()
        let url = `/game/stimulus/mode/`
        try {
            let result = await axios.put(url, data, {
                headers: authHeader(),
            })
            endLoading()
            return 'success';
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
}


// WEBPACK FOOTER //
// ./src/http/componentsAPI/index.js